import { createContext, ReactElement, ReactNode, useContext } from 'react';

export type CasinoGamesFetchDisabledProviderProps = {
  children: ReactNode;
  value: {
    isFetchDisabled: boolean;
    setIsFetchDisabled: (value: boolean) => void;
  };
};

const CasinoGamesFetchDisabledContext = createContext<
  CasinoGamesFetchDisabledProviderProps['value']
>({
  isFetchDisabled: false,
  setIsFetchDisabled: () => {}
});

export const CasinoGamesFetchDisabledProvider = (
  props: CasinoGamesFetchDisabledProviderProps
): ReactElement => {
  return (
    <CasinoGamesFetchDisabledContext.Provider value={props.value}>
      {props.children}
    </CasinoGamesFetchDisabledContext.Provider>
  );
};

export const useCasinoGamesFetchDisabledValues =
  (): CasinoGamesFetchDisabledProviderProps['value'] => {
    return useContext(CasinoGamesFetchDisabledContext);
  };
